import React from "react";
import { connect } from "react-redux";
import { logIn, fetch, cadastrarGrupo } from "../../actions";
import * as api from "./AuthApi";
import Mensagens from "../../components/Mensagens";
import { useSave } from "../../components/Hooks/Conexao";
import { Button } from "antd";
import Fundo from "../../assets/login_bg.png";
import { useParams } from "react-router-dom";

function CadastroGrupoToken(props) {
    const { chave, token, pdv, versao } = useParams();

    const [cadastrar, cadastrando] = useSave(() => api.register(props.fetch, { chave, token }, versao), res => {
        if (res?.errorMsg)
            Mensagens.showErro(res.errorMsg);

        props.cadastrarGrupo(res);
    }, { onRejected: error => { Mensagens.showErro(error); } });

    function salvar(e) {
        e.preventDefault();

        if (!token) return Mensagens.showErro("token não informado!");

        cadastrar();
    }

    return <div style={{ height: "100vh", background: `url(${Fundo}) no-repeat`, backgroundSize: "cover", backgroundColor: "#fff", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <form onSubmit={salvar}>
            <div style={{ width: 600, borderRadius: 4, padding: 30, marginTop: -100 }}>
                <h3 style={{ textAlign: "center" }}>Cadastrar PDV: {pdv}</h3>

                <Button data-cy="btn-login" type="primary" style={{ width: "100%", background: "#fff", color: "#333", fontWeight: "bold", borderColor: "#ddd", borderRadius: 20, marginTop: 10 }} htmlType="submit" loading={cadastrando}>
                    {cadastrando ? "Cadastrando..." : "Cadastrar"}
                </Button>
            </div>
        </form>
    </div>;
}
const mapStateToProps = state => ({ acessoRevogado: state.auth.acessoRevogado });

export default connect(mapStateToProps, { logIn, fetch, cadastrarGrupo })(CadastroGrupoToken);